/**
 * Utilitário para encontrar usuários vinculados.
 * 
 * Critérios de Vínculo:
 * - Mesmo IP (Simulado ou Real)
 * - Mesmo Telefone
 * - Mesmo Email
 */

/**
 * Find users linked to a target based on IP, Phone, or Email.
 * @param {string} targetUserId - The Discord ID of the target user
 * @param {Object} allUsers - Object containing all users keyed by discordId
 * @param {Object} fallbackData - Optional fallback data with ip, email, phone (e.g., from punishment.capturedData)
 * @returns {Array} Array of linked users with linkReason field
 */
export const findLinkedUsers = (targetUserId, allUsers = {}, fallbackData = null) => {
    const targetUser = allUsers[targetUserId];

    // Get identification data from user or fallback (punishment capturedData)
    const targetIP = targetUser?.ip || fallbackData?.ip || null;
    const targetPhone = targetUser?.phone || fallbackData?.phone || null;
    const targetEmail = targetUser?.email || fallbackData?.email || null;

    // If we have no identification data at all, return empty
    if (!targetIP && !targetPhone && !targetEmail) {
        console.log('[LinkingUtils] No identification data available for linking');
        return [];
    }

    const linkedUsers = [];
    const usersList = Object.values(allUsers);

    usersList.forEach(user => {
        // Ignorar o próprio usuário
        if (user.discordId === targetUserId) return;

        let reason = [];

        // Verifica vínculos - case insensitive comparison for email
        if (targetIP && user.ip && user.ip === targetIP) {
            reason.push('IP');
        }

        if (targetPhone && user.phone && user.phone === targetPhone) {
            reason.push('Telefone');
        }

        if (targetEmail && user.email && user.email.toLowerCase() === targetEmail.toLowerCase()) {
            reason.push('Email');
        }

        // Se encontrou algum vínculo, adiciona à lista
        if (reason.length > 0) {
            linkedUsers.push({
                ...user,
                linkReason: reason
            });
        }
    });

    console.log(`[LinkingUtils] Found ${linkedUsers.length} linked users for ${targetUserId}`);
    return linkedUsers;
};
